import { LanguageCodeType } from '@utils/types';

import { FiatCurrencyEnum, PhoneFormatsType } from '@modules/global/types';
import { ProtectNextEnum, VerifyNextEnum } from '@modules/types';

export enum SimplifiedKYCRibStatusesEnum {
  failed = 'failed',
  complete = 'complete',
  progress = 'progress',
  need_inn = 'need_inn',
  error = 'error',
  need_sumsub_verification = 'need_sumsub_verification',
  not_support_country = 'not_support_country',
  failed_bank_wallet = 'failed_bank_wallet',
}

export enum VerificationStatusesEnum {
  incomplete = 'incomplete',
  under_review = 'under_review',
  complete = 'complete',
  failed = 'failed',
  need_email = 'need_email',
}

// user/data

export type UserEmptyResponse = {
  status: number;
};

export type BillingAddressParams = {
  city: string;
  zip_code: string;
  state_code: string;
  country_code: string;
  street_line_1: string;
  street_line_2: string;
};

export type GetUserDataResponse = {
  first_name: string | null;
  last_name: string | null;
  first_name_en: string | null;
  last_name_en: string | null;
  birthday: string | null;
  country_code: PhoneFormatsType;
  language_code: LanguageCodeType;
  fiat_currency: FiatCurrencyEnum;
  send_marketing_material: boolean;
  is_card_enabled: boolean;
  email: string;
  phone: string | null;
  session_id?: string;
  referral: string;
  uuid4: string;
  has_password: boolean;
  vip: boolean;
  dynamic_vip: boolean;
  strong_security: boolean;
  billing_address?: Partial<BillingAddressParams> | null;
  checks: {
    sanction: VerificationStatusesEnum;
    document: VerificationStatusesEnum;
    proof_of_address: VerificationStatusesEnum;
    simplified_identification_status?: {
      rib: SimplifiedKYCRibStatusesEnum;
    };
    document_details: {
      face_type: string;
      document_type: string;
      check_enabled: boolean;
      errors:
        | {
            type: string;
            error: string;
          }[]
        | null;
    };
    review_status?: {
      status?: string;
      errors?: string[];
    };
  };
  iban_status: IbanStatusesEnum;
};

// user/edit

export type EditUserParams = {
  country_code?: PhoneFormatsType;
  billing_address?: BillingAddressParams;
  language_code?: string;
  fiat_currency?: FiatCurrencyEnum;
  send_marketing_material?: boolean;
  send_notification?: boolean;
  strong_security?: boolean;
  zh_agree_complete?: boolean;
};

export type EditUserResponse = {
  language_code: LanguageCodeType;
  fiat_currency: FiatCurrencyEnum;
  billing_address: BillingAddressParams;
  send_marketing_material: boolean;
  send_notification: boolean;
  strong_security: boolean;
  token?: string;
  timeout?: number;
};

// user/toggle-strong-security

export type ToggleStrongSecurityParams = {
  strong_security?: boolean;
  code?: string;
};

export type ToggleStrongSecurityResponse = {
  strong_security: boolean;
  next: ProtectNextEnum;
  timeout?: number;
};

// user/change-email

export type UserEditResponse = {
  [key in 'phone' | 'email']?: string;
} & {
  key: string;
  code_length: number;
  token?: string;
  next?: VerifyNextEnum | ProtectNextEnum;
  timeout: number;
};

// user22/change-email/send-old-email

export type SendOldEmailParams = {
  captcha?: string;
};

export type SendOldEmailResponse = UserEditResponse;

// user22/change-email/verify-password

export type ChangeEmailVerifyPasswordParams = {
  token?: string;
  password: string;
};

export type ChangeEmailVerifyPasswordResponse = {
  token: string;
  next: VerifyNextEnum;
};

// user22/change-email/verify-old-email

export type ChangeEmailVerifyEmailParams = {
  key: string;
  code: string;
};

// user22/change-email/verify-otp

export type ChangeEmailVerifyOTPParams = {
  token: string;
  code: string;
};

export type ChangeEmailVerifyOldEmailResponse = {
  token: string;
  next: VerifyNextEnum | ProtectNextEnum;
};

// user22/change-email/send-new-email

export type ChangeEmailSendNewEmailParams = {
  token?: string;
  email: string;
  send_marketing_material: boolean;
  captcha?: string;
};

export type ChangeEmailSendNewEmailResponse = UserEditResponse;

// user/change-email/verify-phone

export type ChangeEmailVerifyPhoneParams = {
  key: string;
  code: string;
};

export type ChangeEmailVerifyPhoneResponse = UserEditResponse;

// user/change-email/verify-email

export type ChangeEmailVerifyEmailResponse = UserEditResponse;

// user/change-phone

export type ChangePhoneParams = {
  phone: string;
  captcha?: string;
};

export type ChangePhoneResponse = UserEditResponse;

// user/change-phone/verify-email

export type ChangePhoneVerifyEmailParams = {
  key: string;
  code: string;
};

export type ChangePhoneVerifyEmailResponse = UserEditResponse;

// user/change-phone/verify-phone

export type ChangePhoneVerifyPhoneParams = {
  key: string;
  code: string;
};

export type ChangePhoneVerifyPhoneResponse = UserEditResponse;

// user/document-credentials

export type SetDocumentCredentialsParams = {
  passport_serial: string;
  passport_number: string;
  inn: string;
  first_name: string;
  last_name: string;
  provider: string;
};

// user/change-password

export type ChangePasswordParams = {
  password: string;
  new_password: string;
};

export type ChangePasswordResponse = UserEditResponse;

// user/change-password/verify-phone

export type ChangePasswordVerifyPhoneParams = {
  key: string;
  code: string;
};

// user/change-password/verify-email

export type ChangePasswordVerifyEmailParams = {
  key: string;
  code: string;
};

// user/check-document

export type CheckDocumentType =
  | 'check_passport'
  | 'check_id_card'
  | 'check_face_retry'
  | 'check_passport_retry'
  | 'check_id_card_front_retry'
  | 'check_id_card_back_retry';

export type CheckDocumentsParams = {
  type: CheckDocumentType;
};

// user/kyc-access-token
export type AccessKYCTokenParams = {
  kyc2?: boolean;
};

export type AccessKYCTokenResponse = {
  id: number;
  token: string;
  applicant_id: string;
  mobile_sumsub_flow: string;
  web_sumsub_flow: string;
};

// user/edit-unconfirmed-data ?????

// file/types ??????

export type GETFileTypeResponse = {
  [key in string]: string;
};

// user/upload

export type UploadTypesType = 'passport' | 'id_card_front' | 'id_card_back' | 'face';

export type POSTUploadParams = {
  type: UploadTypesType;
  filename?: string;
  content: string;
};

// verification/zendesk

export type VerificationZendeskResponse = {
  token: string;
};

// user/change-password

export type ChangeNewPasswordParams = {
  password?: string;
  new_password?: string;
  captcha?: string;
  key?: string;
};

export type ChangeNewPasswordResponse = {
  key: string;
  next: VerifyNextEnum;
  timeout?: number;
  token?: string;
};

// user/change-password/send-email
export type ChangePasswordSendEmailParams = {
  password: string;
  key?: string;
  captcha?: string;
};

export type ChangePasswordSendEmailResponse = {
  key: string;
  token?: string;
  next: VerifyNextEnum | ProtectNextEnum;
  timeout: number;
  code_length: number;
  masked: string;
};

// user/change-password/set-password
export type ChangePasswordSetPasswordParams = {
  new_password: string;
  key: string;
};

export type ChangePasswordSetPasswordlResponse = {
  timeout: number;
  token: string;
};

// referal branch
export type TBranchData = {
  data: string;
  data_parsed: {
    '+clicked_branch_link': boolean;
    '+is_first_session': boolean;
    referral_code?: string;
  };
  developer_identity: string | null;
  has_app: boolean;
  identity: string | null;
  referring_identity: string | null;
  referring_link: string | null;
};

export enum IbanStatusesEnum {
  forbidden = 'forbidden',
  user_has_intention = 'user_has_intention',
  available = 'available',
  allowed = 'allowed',
  created = 'created',
  unknown = 'unknown',
}

// user/kyc-status

export type UserKYCStatusResponse = {
  is_iban_allowed: boolean;
  is_kyc2_allowed: boolean;
};

// user/zero-hash-agreement

export type UserZHAgreement = {
  zh_agree_need: boolean;
};

// user/zero-hash-disclaimer

export type UserZHDisclaimer = {
  zh_disclaimer_show: boolean;
};

// otp/setup

export type OTPSetup = {
  otp_url: string;
  otp_seed: string;
};

// otp/confirm

export type OTPConfirm = {
  code: string;
};

// otp/verify

export type OTPVerify = {
  code: string;
  key: string;
};

// user22/kyc-address

export type GetKycAddressResponse = {
  city: string;
  zip_code: string;
  state_code: string;
  country_code: string;
  street_line_1: string;
  street_line_2: string;
};
